<template>
	<div class="products container-fluid is-paddingless">
		<Loading :active.sync="isLoading"></Loading>
		<div class="section is-paddingless">
			<div class="columns">
				<ProductFilters
					v-bind:class="[isAsideHidden ? hidden : '', visible]"
					:_submitFilters="submitFilters"
					:_submitFiltersUserProd="submitFiltersUserProd"
					:_getFilteredTags="getFilteredTags"
					:_filteredCountries="filteredCountries"
					:_getFilteredCountries="getFilteredCountries"
					:_getCategories="getCategories"
					:_filters="filters"
					:_categories="categories"
					:_params="params"
					:_isKeywordActive="isKeywordActive"
					:_dates="dates"
					:_clearsearch="clearSearch"
					:_continents="continents"
					:_counties="counties"
					:_countries="countries"
					:_cities="cities"
					:_getCities="getCities"
					:_isFetching="isFetching"
					:_tags="tags"
					:_filteredTags="filteredTags"
					:_resultCount="details.count"
					:_allCount="details.count_all"
				/>

				<div
					v-bind:class="{ toggler_active: isAsideHidden }"
					class="toggler has-background-primary has-ribbon pointer"
					v-on:click="isAsideHidden = !isAsideHidden"
					@mouseover="hover = true"
					@mouseleave="hover = false"
				>
					<span v-if="isAsideHidden" class="toggle-icon-aside">
						<b-icon size="is-medium" type="is-danger" custom-class="is-block" icon="chevron-right"></b-icon>
					</span>
					<span v-if="hover && !isAsideHidden" class="toggle-icon-aside">
						<b-icon size="is-medium" type="is-primary" custom-class="is-block" icon="chevron-left"></b-icon>
					</span>
				</div>

				<section class="column section results">
					<div class="container">
						<FeaturedCountriesFilter />
						<div v-if="details.count > 0">
							<b-pagination
								:total="details.count"
								:current.sync="details.page"
								range-before="3"
								range-after="3"
								per-page="30"
								@change="changePage"
								order="is-centered"
								size="is-small"
								:icon-prev="prevIcon"
								:icon-next="nextIcon"
							></b-pagination>
							<b-pagination-button
								slot="previous"
								slot-scope="props"
								:page="props.page"
								tag="button"
								@click="prevPage()"
							>
								Előző
							</b-pagination-button>

							<b-pagination-button slot="next" slot-scope="props" :page="props.page" tag="button" @click="nextpage()">
								Következő
							</b-pagination-button>
							<hr>
						</div>
						<div v-if="details.count > 0" class="productgrid">
							<ProductCard
								v-for="(bid, index) in bids"
								:key="index"
								:_bid="bid"
								:_lang="
									bid.Product.long_description
										? JSON.parse(bid.Product.long_description)
										: {
												en: {
													name: bid.Product.name,
													description: bid.Product.description,
												},
												}
								"
								:_index="index"
								:_currency="currency"
								:_time="time"
								:_singleProduct="singleProduct"
								:_cardTagfilter="cardTagfilter"
							/>
						</div>
						<div v-if="
							details.count == 0 && loading == 0
							|| details.count == null
							|| loading > 0
						">
							<div class="hero-body">
								<div class="container has-text-centered">
									<h2 v-if="details.count == 0 && loading == 0" class="title">{{ $t('No results…') }}</h2>
									<h2 v-if="details.count == null || loading > 0"  class="title">{{ $t('Loading…') }}</h2>
								</div>
							</div>
						</div>
						<div v-if="details.count > 0">
							<hr>
							<b-pagination
								:total="details.count"
								:current.sync="details.page"
								range-before="3"
								range-after="3"
								per-page="30"
								@change="changePage"
								order="is-centered"
								size="is-small"
								:icon-prev="prevIcon"
								:icon-next="nextIcon"
							></b-pagination>
							<b-pagination-button
								slot="previous"
								slot-scope="props"
								:page="props.page"
								tag="button"
								@click="prevPage()"
							>
								Előző
							</b-pagination-button>

							<b-pagination-button slot="next" slot-scope="props" :page="props.page" tag="button" @click="nextpage()">
								Következő
							</b-pagination-button>
						</div>
					</div>
				</section>
			</div>
		</div>
	</div>
</template>
<script>
import Loading from 'vue-loading-overlay'
import ProductFilters from '@/components/frontend/products/ProductFilters.vue'
import FeaturedCountriesFilter from '@/components/common/FeaturedCountriesFilter'
import ProductCard from '@/components/frontend/products/ProductCard.vue'
// eslint-disable-next-line no-unused-vars
import lodash from 'lodash'
import debounce from 'lodash/debounce'

import { store } from '@/store'

export default {
	name: 'Products',
	components: {
		ProductFilters,
		Loading,
		FeaturedCountriesFilter,
		ProductCard,
		// eslint-disable-next-line vue/no-unused-components
		debounce, // tag-hez kell
	},
	metaInfo () {
		// console.log('meta:::', this.$route.params.maincategory, this.getCategoryTitle, this.mainCategory.id)
		return {
			title: this.loading ? this.$t("Loading…") : (this.$route.params.maincategory ? this.getCategoryTitle : this.$t("All products"))
		}
	},
	data() {
		return {

			//_this: this
			categories: [],
			mainCategory: [],
			continents: [],
			counties: [],
			countries: [],
			cities: [],
			tags: [],
			selected: null,
			isFetching: false,
			value: 0,
			isConnected: false,
			currency: localStorage.getItem('currency') || 'HUF',
			socketMessage: '',
			msg: 'response',
			//t/ime: this.$moment(),
			loading: 0,
			isAsideHidden: false,
			// products: [],
			bids: [],
			visible: 'visible',
			hidden: 'is-hidden',
			time: this.$moment(),
			time_local: this.$moment(),
			time_server: this.$moment(),
			path: '',
			timerIsRun: false,
			durationTime: 0,
			isKeywordActive: 'false',
			dates: [],
			filteredCountries: this.countries,
			filteredCounties: this.counties,
			filteredTags: this.tags,
			bidSample: {
				price: null,
				finish: null,
			},
			auction: null,
			// Pager
			total: this.resultCount,
			prevIcon: 'chevron-left',
			nextIcon: 'chevron-right',
			details: { count_all: null, count: null, page: this.$store.getters.getFilters.page, pages: [1] },
			submitRun: false,
			hover: false
		}
	},
	watch: {
		'$route.params': {
			handler() {
				console.log('CLICK')
				//this.init();
				if (this.submitRun == false) {
					this.submitRun = true
					const category = JSON.parse(localStorage.getItem('category'))
					this.getDates((dates) => {
						console.log('localStorage', category, dates)
						if (category) {
							localStorage.removeItem('category')
							this.cardTagfilter(category)
							this.init()
						} else {
							//this.clearSearch();
							console.log('route params submitFilters')
							this.init()
							//this.submitFilters();
						}
					})
				}
			},
			immediate: true,
		},
	},
	mounted() {
		this.getMainCategory()
		if(typeof this.$route.query.keyword != 'undefined' ){
			console.log("nem undefined")
			this.filters.keyword = this.$route.query.keyword; 
		}
		if (this.submitRun == false) {
			this.submitRun = true;
			this.init()
		}
		var _this = this
		this.$root.$on('refreshFilters', (category) => {
			_this.cardTagfilter(category)
		})
	},
	methods: {
		init() {
			var _this = this
			_this.getActiveAuction(function (err) {
				console.log('getActiveAuction:', err)
				_this.$checkLoggedIn(
					_this,
					function () {
						_this.getDates(() => {
							_this.getContinents(() => {
								_this.getCounties(() => {
									_this.getCountries(() => {
										_this.getTags(() => {
											console.log('mounted submitFilters')
											_this.submitFilters(true)
										})
									})
								})
							})
						})
						//}
					},
					true
				)
			})
			const category = JSON.parse(localStorage.getItem('category'))
			console.log('localStorage', category)
			if (category) {
				localStorage.removeItem('category')
				_this.cardTagfilter(category)
			}
		},
		changePage(id) {
			this.details.page = id
			this.submitFilters(true)
		},
		getActiveAuction(cb) {
			var _this = this
			_this.$http
				.get('/products/latest')
				.then((response) => {
					_this.auction = response.data.Auction.id
					console.log('LATEST:', _this.auction)
					if (typeof cb == 'function') {
						cb(null)
					}
				})
				.catch(function (err) {
					if (typeof cb == 'function') {
						cb(err)
					}
				})
		},
		// categories
		getMainCategory(){
			var _this = this
			var cid = this.$route.params.maincategory
			if (typeof this.$route.params.maincategory !== 'undefined') {
				this.loading += 1
				_this.$http.get('/category/' + cid).then((response) => {
					_this.mainCategory = response.data.category
					_this.loading -= 1
					console.log('mainCategory:', _this.mainCategory)
				})
			}
		},
		getCategories() {
			var _this = this
			_this.$http.get('/categories/parent/' + this.$route.params.id).then((response) => {
				_this.categories = response.data.category
			})
		},
		getCities: debounce(function (name) {
			if (!name.length) {
				this.cities = []
				return
			}
			this.isFetching = true
			this.$http
				.get('/categories/cities', { params: { name: name, counties: true } })
				.then(({ data }) => {
					this.cities = []
					data.categories.forEach((item) => this.cities.push(item))
				})
				.catch((error) => {
					this.cities = []
					throw error
				})
				.finally(() => {
					this.isFetching = false
				})
		}, 500),
		// continents
		getContinents(cb) {
			var _this = this
			_this.$http.get('/categories/continents').then((response) => {
				_this.continents = response.data.categories
				if (typeof cb == 'function') {
					cb()
				}
			})
		},
		// counties
		getCounties(cb) {
			var _this = this
			_this.$http.get('/categories/counties').then((response) => {
				_this.counties = response.data.categories
				if (typeof cb == 'function') {
					cb()
				}
			})
		},
		getFilteredCounties(text) {
			console.log(text)
			this.filteredCounties = this.countries.filter((option) => {
				return this.$i18n.locale == 'hu' ? option.name : option.languages.en
			})
		},
		// Countries
		getCountries(cb) {
			var _this = this
			_this.$http.get('/categories/countries', { params: { continents: true } }).then((response) => {
				_this.countries = response.data.categories
				if (typeof cb == 'function') {
					cb()
				}
			})
		},
		getFilteredCountries(text) {
			this.filteredCountries = this.countries.filter((option) => {
				return (
					option.name.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0 ||
					(option.languages.en ? option.languages.en : '').toString().toLowerCase().indexOf(text.toLowerCase()) >= 0
				)
			})
		},
		// tags
		getTags(cb) {
			var _this = this
			_this.$http.get('/categories/tags').then((response) => {
				_this.tags = response.data.categories
				if (typeof cb == 'function') {
					cb()
				}
			})
		},
		getFilteredTags(text) {
			this.filteredTags = this.tags.filter((option) => {
				return (
					option.name.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0 ||
					option.lang.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0
				)
			})
		},
		getDates(cb) {
			var _this = this
			var url = '/products/minmaxdates/'
			if (typeof this.$route.params.maincategory !== 'undefined') {
				url = '/products/minmaxdates/' + this.$route.params.maincategory
			}
			_this.$http
				.get(url)
				.then((response) => {
					_this.dates = [response.data.dates.min, response.data.dates.max]
					_this.$store.commit('setDates', _this.dates)
					console.log('dates:', _this.dates)
					this.$root.$emit('getDates', _this.dates)
					if (typeof cb == 'function') {
						cb()
					}
				})
				.catch((err) => {
					console.log('getDates:', err)
					if (typeof cb == 'function') {
						cb()
					}
				})
		},
		singleProduct(id) {
			localStorage.setItem('filters', JSON.stringify(this.$store.getters.getFilters))
			localStorage.setItem('params', JSON.stringify(this.$store.getters.getParams))
			this.$router.push({ name: 'Product', params: { id } })
		},
		clearSearch(keywords) {
			if(typeof keywords == 'undefined'){
				keywords = true;
			}
			console.log('============CLEAR SEARCH===========')
			this.$router.replace({ name: "Products", query: null });

			this.filters.isBiddedProductsSwitched = false
			this.filters.isFavoritesProductsSwitched = false
			this.filters.isUploadedProductsSwitched = false
			this.filters.isFinishedProductsSwitched = true
			this.filters.category = null
			this.filters.countries = []
			this.filters.counties = []
			this.params.cities = []
			this.filters.keyword = ''
			this.params.countries = []
			this.params.tags = []
			this.params.dates = [this.dates[0], this.dates[1]]
			localStorage.removeItem('filters')
			localStorage.removeItem('params')
			this.submitFilters()
		},
		cardTagfilter(category, submit) {
			if (typeof submit == 'undefined') {
				submit = true
			}
			var _this = this
			let i
			if (category.type == 2 || category.type == 3) {
				let f = false
				for (i = _this.params.countries.length - 1; i >= 0; i--) {
					if (_this.params.countries[i].id == category.id) {
						f = true
						break
					}
				}
				if (f == false) {
					_this.params.countries.push(category)
				}
				if (submit) {
					_this.submitFilters()
				}
			}
			if (category.type == 4 || category.type == 5) {
				let f = false
				for (i = _this.params.cities.length - 1; i >= 0; i--) {
					console.log(_this.params.cities[i].id, category.id)
					if (_this.params.cities[i].id == category.id) {
						f = true
						break
					}
				}
				console.log('CITIES:', _this.params.cities)
				if (f == false) {
					_this.params.cities.push(category)
				}
				if (submit) {
					_this.submitFilters()
				}
			}
			if (category.type == 6) {
				let f = false
				for (i = _this.params.tags.length - 1; i >= 0; i--) {
					if (_this.params.tags[i].id == category.id) {
						f = true
						break
					}
				}
				if (f == false) {
					_this.params.tags.push(category)
				}
				if (submit) {
					_this.submitFilters()
				}
			}
		},
		prevPage() {
			var _this = this
			_this.filters.page = _this.details.page -= 1
			localStorage.setItem("filters", JSON.stringify(_this.filters))
			_this.submitFilters()
		},
		nextpage() {
			var _this = this
			_this.filters.page = _this.details.page += 1
			localStorage.setItem("filters", JSON.stringify(_this.filters))
			_this.submitFilters()
		},
		getFiltersFromStorage() {
			const filters = JSON.parse(localStorage.getItem('filters'))
			const params = JSON.parse(localStorage.getItem('params'))
			const _this = this
			if (params) {
				_this.params = params
				_this.params.dates = params.dates
			}
			if (filters) {
				//_this.filters = {...filters};
				_this.filters.page = filters.page;
				_this.filters.isFinishedProductsSwitched = filters.isFinishedProductsSwitched
				_this.filters.isBiddedProductsSwitched = filters.isBiddedProductsSwitched
				_this.filters.isFavoritesProductsSwitched = filters.isFavoritesProductsSwitched
				_this.filters.isUploadedProductsSwitched = filters.isUploadedProductsSwitched
				/*if(typeof _this.$route.query.k != 'undefined' ){
					console.log("XXOOO nem undefined")
					_this.filters.keyword = _this.$route.query.k; 
				}else{
					console.log("XXOOO undefined")
				}*/
				_this.filters.keyword = filters.keyword
				_this.cities = params.cities
				console.log('FILTERS:', filters, _this.filters)
				//_this.dates  = params.dates;
				filters.tags.forEach((val) => {
					const _category = _this.tags.filter((category) => category.id == val)
					if (_category.length > 0) {
						_this.cardTagfilter(_category[0], false)
					}
				})
				filters.countries.forEach((val) => {
					const _category = _this.countries.filter((category) => category.id == val)
					if (_category.length > 0) {
						_this.cardTagfilter(_category[0], false)
					}
				})
				console.log('CITIES:', _this.cities)
				filters.cities.forEach((val) => {
					const _category = _this.cities.filter((category) => category.id == val)
					console.log('CITI:', _category)
					if (_category.length > 0) {
						_this.cardTagfilter(_category[0], false)
					}
				})
			}
			localStorage.removeItem('filters')
			localStorage.removeItem('params')
		},
		submitFiltersUserProd(notResetPage, _filters_) {
			this.submitFilters(notResetPage, _filters_, true);
		},
		submitFilters(notResetPage, _filters_, clear) {
			this.$root.$emit('hideFastbid')
			var _this = this
			if (notResetPage == true) {
				this.filters.page = this.details.page
			} else {
				this.filters.page = 1
			}

			if (this.filters.isUploadedProductsSwitched) {
				if(clear == true){
					this.clearSearch(true)
				}
				this.filters.isFinishedProductsSwitched = true
				this.filters.isUploadedProductsSwitched = true
			}



			this.getFiltersFromStorage()
			this.filters.countries = this.lodash.map(this.params.countries, 'id')
			this.filters.tags = this.lodash.map(this.params.tags, 'id')
			this.filters.cities = this.lodash.map(this.params.cities, 'id')

			this.filters.category = this.$route.params.maincategory
			this.filters.dates = this.params.dates
			this.filters.auction = this.auction

			if (_filters_) {
				if (_filters_.dates) {
					this.filters.dates = _filters_.dates
				}
				console.log('FILTERS:', this.filters.dates, _filters_)
			}
			if (this.filters.category) {
				this.path = 'category/' + this.filters.category
			} else {
				this.path = 'products'
			}
			let _productEndpoint = 'search'
			this.loading += 1
			console.log('___XXX___', this.$store.getters.loggedIn)
			if (this.$store.getters.loggedIn == true) {
				_productEndpoint = 'products'
			}
			// console.log("lenght", this.filters.keyword.length);
			// if (this.filters.keyword.length == 0 ) {
			//   this.$buefy.snackbar.open({
			//     message: _this.$t("Empty"),
			//     type: 'is-danger',
			//     queue: false,
			//   });
			// }
			if(typeof this.$route.query.k != 'undefined' ){
				console.log("OOOOO nem undefined")
				this.filters.keyword = this.$route.query.k; 
			}

			_this.bids = []
			this.$http
				.post(_productEndpoint, {
					filters: _this.filters,
				})
				.then((response) => {
					_this.getMainCategory()
					_this.bids = response.data.bids
					_this.details = response.data.details
					console.log(_this.details)
					_this.loading -= 1
					_this.submitRun = false
				})
				.catch((error) => {
					_this.submitRun = false
					_this.loading -= 1
					console.log(error)
				})
			if(_this.filters.keyword !== ''){
				_this.$router.replace({ name: "Products", query: {k:_this.filters.keyword} });
			}
		},
		calcRemainingTime(_this) {
			_this.time = _this.$moment().add(_this.durationTime) //.format('YYYY-MM-DD HH:mm:ss');
			//console.log("duration prodlist:", _this.durationTime.as('milliseconds'), _this.time.milliseconds())
			setTimeout(function () {
				_this.calcRemainingTime(_this)
			}, 1100 - _this.time.milliseconds())
		},
	},
	computed: {
		isLoading() {
			return this.loading != 0
		},
		getCategoryTitle() {
			// JSON.parse(mainCategory.lang)[$i18n.locale]
			if (typeof(this.mainCategory) === 'undefined') return undefined
			if (this.$i18n.locale == 'hu'){
				return this.mainCategory.name
			} else {
				return this.mainCategory.lang ? JSON.parse(this.mainCategory.lang)[this.$i18n.locale] : '('+this.mainCategory.name+')'
			}
		},
		filters: {
			get: function () {
				return store.getters.getFilters
			},
			set: function (val) {
				store.setFilters = val
			},
		},
		params: {
			get: function () {
				return store.getters.getParams
			},
			set: function (val) {
				store.setParams = val
			},
		},
		resultCount() {
			return this.bids && this.bids.length
		},
	},
	sockets: {
		connect() {
			// Fired when the socket connects.
			this.isConnected = true
			//console.log("connect");
		},

		disconnect() {
			this.isConnected = false
			console.log('disconnect')
		},

		respLicit(data) {
			//console.log("data:", data);
			this.socketMessage = data
		},
		serverTime(data) {
			console.info('PRODUCTS SERVER TIME:', data)
			var _this = this
			if (_this.timerIsRun == false) {
				const servertime = _this.$moment(data)
				_this.durationTime = _this.$moment.duration(servertime.diff(this.$moment()))
				_this.calcRemainingTime(_this)
				_this.timerIsRun = true
			}
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.inactive {
	opacity: 0.7;
	background: #eee7e7;
}

.productgrid {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
	grid-gap: 1rem;
	margin: 1.5rem 0;
}

.toggler {
	width: 1rem;
	opacity: 0.3;
	transition: 0.4s;
}
.toggler:hover {
	opacity: 0.9;
}
.toggler_active {
	opacity: 0.9;
}
.product-filters {
	padding: 0;
}
.toggle-icon-aside {
	padding-top: 2rem;
	margin-left: 1rem;
	position: fixed;
}

.products .columns {
	margin: 0;
}

* >>> .pagination-link {
	background-color: white;
}
* >>> .pagination-link.is-current {
	background-color: #1A454A;
}
</style>
